/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { ClosedEnum } from "../../types/enums.js";

/**
 * Additional detail for a verification status.
 *
 * @deprecated enum: This will be removed in a future release, please migrate away from it as soon as possible.
 */
export const VerificationStatusDetail = {
  FailedAutoVerify: "failedAutoVerify",
  DocDobMismatch: "docDobMismatch",
  DocNameMismatch: "docNameMismatch",
  DocAddressMismatch: "docAddressMismatch",
  DocNumberMismatch: "docNumberMismatch",
  DocIncomplete: "docIncomplete",
  DocFailedRisk: "docFailedRisk",
  PotentialAccountSanctionsMatch: "potentialAccountSanctionsMatch",
  PotentialRepresentativeSanctionsMatch:
    "potentialRepresentativeSanctionsMatch",
  FailedOther: "failedOther",
} as const;
/**
 * Additional detail for a verification status.
 *
 * @deprecated enum: This will be removed in a future release, please migrate away from it as soon as possible.
 */
export type VerificationStatusDetail = ClosedEnum<
  typeof VerificationStatusDetail
>;

/** @internal */
export const VerificationStatusDetail$inboundSchema: z.ZodNativeEnum<
  typeof VerificationStatusDetail
> = z.nativeEnum(VerificationStatusDetail);
/** @internal */
export const VerificationStatusDetail$outboundSchema: z.ZodNativeEnum<
  typeof VerificationStatusDetail
> = VerificationStatusDetail$inboundSchema;
